import { Database, Info } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import AutoBackupPanel from '@/components/hq/AutoBackupPanel';

const Backup = () => (
  <div className="p-6 space-y-6" data-testid="backup-page">
    <div>
      <h1 className="text-2xl font-bold flex items-center gap-2">
        <Database className="w-6 h-6 text-blue-600" /> Database Backup
      </h1>
      <p className="text-gray-500">
        Automatic daily backups to Bunny CDN, one-click manual backup, and success/failure alerts on the HQ desktop.
      </p>
    </div>

    <AutoBackupPanel />

    <Card className="border-blue-100 bg-blue-50/40">
      <CardContent className="pt-6">
        <div className="flex gap-4">
          <Info className="w-6 h-6 text-blue-600 flex-shrink-0" />
          <div className="text-sm text-blue-900 space-y-1">
            <p className="font-semibold">What is inside each backup zip</p>
            <ul className="list-disc ml-5 space-y-0.5">
              <li><span className="font-mono">dump/&lt;db&gt;/*.bson</span> + index metadata — restore with <span className="font-mono">mongorestore --drop dump/</span></li>
              <li><span className="font-mono">backup_data.json</span> — restore from HQ → System Reset &amp; Backup → Restore</li>
              <li><span className="font-mono">manifest.json</span> — every collection with record counts, so nothing is missed</li>
            </ul>
            <p className="text-xs text-blue-700 pt-1">
              Collections are discovered at run time; any collection added in future is backed up automatically.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default Backup;
